import dayjs from 'dayjs';

/**
 * 목록 일자 범위 필터의 공용 프리셋 (L.MES.GUPO.29).
 *
 * POP 진입 화면(`MesPopEntryPage`)에서 쓰던 정의를 끌어올려 SSOT 로 만든 것이다 —
 * 같은 프리셋을 발주·수주 목록에서도 쓰기 위해서다. `el-date-picker` 의 `shortcuts`
 * 규약(`{ text, value: () => [Date, Date] }`)을 그대로 따르므로, `value-format` 이
 * 걸린 픽커에서는 Element Plus 가 문자열로 변환해 v-model 에 넣는다.
 *
 * 순서는 "좁은 것 → 넓은 것" 이며, 달력 좌측 패널에 세로로 쌓인다.
 */
/**
 * 프리셋 사이드바 정렬용 popper 클래스 (L.MES.GUPO.29).
 *
 * 달력 팝퍼는 body 로 teleport 되므로 SFC 의 `<style scoped>` 가 닿지 않는다 —
 * 정렬 규칙은 전역 `style.css` 에 두고, 픽커는 이 클래스를 `popper-class` 로 단다.
 * `DATE_RANGE_SHORTCUTS` 를 쓰는 픽커는 이 클래스도 함께 다는 것을 규약으로 한다.
 */
export const DATE_RANGE_SHORTCUTS_POPPER_CLASS = 'ax-date-range-shortcuts';

export interface DateRangeShortcut {
  text: string;
  value: () => [Date, Date];
}

export const DATE_RANGE_SHORTCUTS: DateRangeShortcut[] = [
  { text: '오늘', value: () => [dayjs().startOf('day').toDate(), dayjs().toDate()] },
  { text: '이번 주', value: () => [dayjs().startOf('week').toDate(), dayjs().toDate()] },
  { text: '이번 달', value: () => [dayjs().startOf('month').toDate(), dayjs().toDate()] },
  {
    text: '지난 달',
    value: () => [
      dayjs().subtract(1, 'month').startOf('month').toDate(),
      dayjs().subtract(1, 'month').endOf('month').toDate(),
    ],
  },
  { text: '최근 1주', value: () => [dayjs().subtract(1, 'week').toDate(), dayjs().toDate()] },
  { text: '최근 1개월', value: () => [dayjs().subtract(1, 'month').toDate(), dayjs().toDate()] },
  { text: '최근 3개월', value: () => [dayjs().subtract(3, 'month').toDate(), dayjs().toDate()] },
  { text: '최근 6개월', value: () => [dayjs().subtract(6, 'month').toDate(), dayjs().toDate()] },
];
